'use strict';

import Common from '../../Utils/Common'

/**
 * @classname Search
 * @classdesc 検索
 */
export default class Search {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('Search.constructor');
		this._$e = $e;
		$e.on('click', () => this.onClick());
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof Search
	 * @return {undefined}
	 */
	 onClick() {
		console.log('Search.onClick');
		let url = this._$e.hasClass('current_search')
			? Common.getCurrentURL()
			: window.const.URL.SEARCH;
		console.log(url);
		let param = Common.getSearchQuery();
		console.log(`${url}${param}`);
		location.href = `${url}${param}`;
	};

};
